import { gql } from '@apollo/client';

export default gql`
  fragment CloudinaryImage on CloudinaryImage {
    publicId
    alt
    caption
    defaultImageUrls
    sources {
      srcSet
      media
      sizes
    }
  }
`;
